import type { FC, ReactNode } from 'react';
import { Link } from '../../atoms/Link';
import {
  StyledCard,
  StyledSignUpLayoutBottomMessage, StyledSignUpLayoutTitle,
} from './SignUpLayout.styles';
import { AuthLayout } from '../AuthLayout';


interface SignUpLayoutProps {
  children: ReactNode;
  title: string;
  bottomSectionConfig?: {
    message: string;
    linkText: string;
    linkHref: string;
  };
  width?: string;
  linkMarginBottom?: string;
  hideCardShadow?: boolean;
}

export const SignUpLayout: FC<SignUpLayoutProps> = ({
  title,
  bottomSectionConfig,
  children,
  width = '460px',
  linkMarginBottom,
  hideCardShadow
}) => (
  <AuthLayout centerVertically>
    <StyledCard
      bordered={false}
      width={width}
      hideShadow={hideCardShadow}
    >
      <StyledSignUpLayoutTitle>
        {title}
      </StyledSignUpLayoutTitle>

      {/* Content renders here */}
      {children}
    </StyledCard>

    {bottomSectionConfig && (
    <StyledSignUpLayoutBottomMessage style={{ marginBottom: linkMarginBottom }}>
      {bottomSectionConfig.message}
&nbsp;
      <Link
        to={bottomSectionConfig.linkHref}
        fontWeight="700"
        fontSize="16px"
      >
        {bottomSectionConfig.linkText}
      </Link>
    </StyledSignUpLayoutBottomMessage>
    )}
  </AuthLayout>
);
